import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Form, Button, Row, Col, ProgressBar } from 'react-bootstrap';
import './addQuestion.css'
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField } from '../../Slices/formSlice';
import CustomButton from '../../../component/button';
import { difficultyLevel } from '../../../constant/dificultyLevel';


const AddQuestion = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const [showAvailableQuestions, setShowAvailableQuestions] = useState(false)

  const dispatch = useDispatch()

  const state = useSelector(state => state?.form)

  const [valiteded, setValiteded] = useState(false);

  const [level, setLevel] = useState('Medium (Limited Experience)')

  const [questionList, setQuestionList] = useState([
    // { id: 1, title: "Behavioral Assessment" },
    // { id: 2, title: "Situational Judgment Test" },
    // { id: 3, title: "Coding Problem" },
  ]);


  const MIN = 3;
  const MAX = 24;
  const [value, setValue] = useState(MIN);
  const [thumbLeft, setThumbLeft] = useState(0);
  const rangeRef = useRef(null);

  const handleSliderChange = (e) => {
    const newValue = Number(e.target.value);
    setValue(newValue);
  };

  const handleSubmit = (event) => {
    event?.preventDefault();
    event?.stopPropagation();

    const form = event?.currentTarget;
    if (!form?.checkValidity()) {
      console.log(form?.checkValidity());
      setValiteded(true);
      return;
    }

    navigate('/JobAnalysis')

  }

  useEffect(() => {
    if (rangeRef.current) {
      const rangeWidth = rangeRef.current.offsetWidth;
      const percent = (state?.num_questions - MIN) / (MAX - MIN);
      const newLeft = percent * rangeWidth;
      setThumbLeft(newLeft);
    }

    if (rangeRef.current) {
      const percent = ((state?.num_questions - MIN) / (MAX - MIN)) * 100;
      rangeRef.current.querySelector('input').style.setProperty('--fill', `${percent}%`);
    }
  }, [state?.num_questions]);
  return (
    <div
      style={{ backgroundColor: '#F2F4F7' }}
      className={`canLisContentWrap `}
    >
      <div className="t-wrapper-div ">
        <main className="flex-1 p-10 bg-white">
          <div className="modal-content">
            <div className='question-header'>
              <div className="canLisTxtStyl">
                <p >Assessment Generator</p>
              </div>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  WebkitDisplay: 'inline-flex',
                }}
              >

              </div>


            </div>
            <Form className=' p-4' noValidate validated={valiteded} onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label style={{ fontSize: '20px', fontWeight: '500', fontFamily: 'Roboto' }} className='mainTitleColr'>Difficulty Level</Form.Label>
                <div>
                  {difficultyLevel.map((value) => (
                    <Form.Check
                      required
                      className='mainTitleColr'
                      style={{ marginBottom: '8px', fontFamily: 'Roboto', fontWeight: '400', fontSize: '16px' }}
                      key={value.value}
                      label={value.label}
                      name="difficulty"
                      type="radio"
                      value={value.value}
                      checked={value.value === state.difficulty_level}
                      onChange={(e) => {
                        dispatch(updateFormField({ field: 'difficulty_level', value: e.target.value }))
                        setLevel(e.target.value)
                      }}
                    />
                  ))}
                </div>
                <Form.Control.Feedback type="invalid">
                  Please Enter Company Name!
                </Form.Control.Feedback>
              </Form.Group>
              <div className=" position-relative">
                <Form.Label style={{ fontSize: '20px', fontWeight: '500', fontFamily: 'Roboto', marginTop: '8px' }} className='mainTitleColr'>Select Number of Questions</Form.Label>

                <div className="position-relative " ref={rangeRef}>
                  <div
                    className="value-bubble"
                    style={{ left: `${thumbLeft}px`, transform: 'translateX(-50%)' }}
                  >
                    {state?.num_questions}
                  </div>
                  <input
                    type="range"
                    min={MIN}
                    max={MAX}
                    value={state.num_questions}
                    className="custom-slider"
                    onChange={(e) => dispatch(updateFormField({ field: 'num_questions', value: e.target.value }))}
                  />

                </div>

                <Row className="">
                  <Col className="text-start"><small>{MIN}</small></Col>
                  <Col className="text-end"><small>{MAX}</small></Col>
                </Row>
              </div>
              <div className="question-modal-footer">
                <CustomButton
                  title="Back"
                  handleClick={() => navigate('/SubTopics')}
                  buttonType="secondary"
                />
                <CustomButton
                  title="Proceed"
                  type='submit'
                />
              </div>


            </Form>



          </div>
        </main>

      </div >
    </div >
  )
}

export default AddQuestion